<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>basic</el-breadcrumb-item>
      <el-breadcrumb-item>代理商管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->

      <collapse @getDataList="search">
        <collapse-item>
          <span>Agent:</span>
          <el-input
            placeholder="please enter name,email,address to search"
            v-model="queryInfoparams.params.keyword"
            clearable
            @change="search"
            @clear="queryInfoparams.params.keyword==null"
          ></el-input>
        </collapse-item>
      </collapse>

      <el-row type="flex" justify="space-between">
        <div class="titleText">Agent Managemen</div>
        <el-button-group class="btnsList">
          <el-button
            plain
            size="small"
            icon="el-icon-plus"
            v-hasPermission="['agent:save']"
            @click="showAddDialog"
          >Add</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-unlock"
            v-hasPermission="['agent:startAgency']"
            @click="enableBatch"
          >Enable</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-lock"
            v-hasPermission="['agent:stopAgency']"
            @click="disableBatch"
          >Disable</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-download"
            v-hasPermission="['agent:export']"
            @click="exportExcel"
          >Export</el-button>
        </el-button-group>
      </el-row>

      <!-- 列表区域 -->
      <el-table
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
      >
        <el-table-column type="selection" width="55"  fixed="left"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="Agent name" sortable="custom" prop="agencyName" width="180"></el-table-column>
        <el-table-column label="Area" prop="country" width="240" show-overflow-tooltip>
          <template
            slot-scope="scope"
          >{{scope.row.suburb}} {{scope.row.city}} {{scope.row.state}} {{scope.row.country}}</template>
        </el-table-column>
        <el-table-column label="Agent address" prop="agencyAddress" width="200"></el-table-column>
        <el-table-column label="Email" prop="email" width="200" ></el-table-column>
        <el-table-column
          label="Total quantity of pressure test"
          sortable="custom"
          prop="pressureNum"
          width="240"
        ></el-table-column>
        <el-table-column
          label="Number of plumbers"
          sortable="custom"
          prop="engineerNum"
          width="200"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="Quantity of last week"
          sortable="custom"
          prop="pressureWeekNum"
          width="200"
        ></el-table-column>
        <el-table-column
          label="Quantity of last month"
          sortable="custom"
          prop="pressureMonthNum"
          width="200"
        ></el-table-column>
        <el-table-column label="Salesman" sortable="custom" prop="salesMan" width="120"></el-table-column>

        <el-table-column
          label="Whether to enable"
          prop="agencyStatus"
          width="150"
          :filters="[{text: 'Enable', value: '0'}, {text: 'Disable', value: '1'}]"
          column-key="agencyStatus"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.agencyStatus === 0 " type="success">Enable</el-tag>
            <el-tag v-else-if="scope.row.agencyStatus === 1 " type="info">Disable</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="Testing standard"
          prop="testStandard"
          :filters="[{text: 'Personal', value: 'PERSONAL'}, {text: 'Standard', value: 'STANDARD'}]"
          column-key="testStandard"
          width="150"
        ></el-table-column>
        <el-table-column label="Operation" width="100px" fixed="right" fit>
          <template slot-scope="scope">
            <el-link icon="el-icon-s-setting" @click="goDetail(scope.row)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 新增对话框-->
    <el-dialog :visible.sync="dialogVisible" width="50%" @close="dialogClosed" slot="title">
      <template slot="title">
        <div>
          <h3>Add Agent</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="250px">
        <el-form-item label=" Agent name" prop="agencyName">
          <el-input v-model="addForm.agencyName" placeholder=" enter the agent name"></el-input>
        </el-form-item>
        <el-form-item label="Invitation code rules" prop="agencyPipelineName">
          <el-input v-model="addForm.agencyPipelineName" placeholder=" enter the two-character"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="addForm.email" placeholder=" enter the email"></el-input>
        </el-form-item>
        <el-row type="flex" justify="start">
          <el-col :span="12">
            <el-form-item label="First name" prop="firstName">
              <el-input v-model="addForm.firstName" placeholder=" enter first name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last name" prop="lastName">
              <el-input v-model="addForm.lastName" placeholder=" enter last name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Testing standard" prop="testStandard">
          <el-radio-group
            v-model="addForm.testStandard"
            v-for="(item,index) in testStandardList"
            :key="index"
          >
            <el-radio-button :label="item.value">{{item.text}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Agent area" prop="agencyArea">
          <el-cascader
            placeholder="select area"
            filterable
            style="width:100%;"
            clearable
            size="small"
            v-model="addForm.agencyArea"
            :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
            :options="areaTreeList"
            ref="treeArea"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="Detail address" prop="agencyAddress">
          <el-input v-model="addForm.agencyAddress" placeholder=" enter ther detail address"></el-input>
        </el-form-item>
        <el-form-item label="Salesman" prop="salesMan">
          <!-- <el-input v-model="addForm.salesMan"></el-input> -->
          <el-select
            v-model="addForm.salesMan"
            filterable
            remote
            clearable
            placeholder="enter name ,account search"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in salemanList"
              :key="item.id"
              :label="item.user_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="save">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'

export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    var checkCodeRule = (rule, value, cb) => {

      const regRule = /^[0-9A-Za-z]{2,2}$/
      if (regRule.test(value)) {
        return cb()
      }
      cb(new Error('Only enter two letters character'))
    }
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 列表
      dataList: [],
      total: 0,
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      // 添加和修改用户的表单数据
      addForm: {
        status: 0,
        testStandard: 'STANDARD',
        agencyPipelineName: '',
      },
      // 添加表单的验证规则对象
      addFormRules: {
        agencyName: [
          {
            required: true,
            message: 'Agent name is required',
            trigger: 'blur',
          },
          {
            max: 300,
            message: 'Agent name can not more than 300 character',
            trigger: 'blur',
          },
        ],
        agencyPipelineName: [
          {
            required: true,
            message: 'Pipeine code is required',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 2,
            message: 'Only enter two letters character',
            trigger: 'blur',
          },
          { validator: checkCodeRule, required: true, trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email' },
          { validate: 'checkEmailExist', trigger: 'blur' },
        ],
        firstName: [
          {
            required: true,
            message: 'First name is required',
            trigger: 'blur',
          },
        ],
        lastName: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
        testStandard: [
          {
            required: true,
            message: 'Testing standard is required',
            trigger: 'blur',
          },
        ],
        agencyAddress: [
          {
            required: true,
            message: 'Agency address is required',
            trigger: 'blur',
          },
        ],
        agencyArea: [
          {
            required: true,
            message: 'Agency Area is required',
            trigger: 'blur',
          },
        ],
      },
      // 控制修改对话框的显示与隐藏
      dialogVisible: false,

      // 查询到的信息
      editForm: {},

      //checkbox选择的只
      multipleSelection: [],

      //下拉框查询参数：状态
      agencyStatus: null,
      //下拉框查询参数：测试标准
      testStandard: '',
      //下拉框数组
      testStandardList: [],

      areaTreeList: [],

      salemanList: [],
      loading: false,
    }
  },
  methods: {
    //搜索saleman
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true

        this.$post('user/searchUser', { userType: '1', keyword: query }).then(
          ({ data: res }) => {
            this.salemanList = res.data
            this.loading = false
          }
        )
      } else {
        this.options = []
      }
    },
    //监控下拉框变化
    filterChange(filters) {
      console.log('---------------', filters)

      //状态
      if (filters.agencyStatus != undefined) {
        var agencyStatus = filters.agencyStatus

        if (
          agencyStatus != undefined &&
          agencyStatus != null &&
          agencyStatus.length > 0
        ) {
          this.queryInfoparams.params.agencyStatus = agencyStatus.join(',')
        } else {
          this.queryInfoparams.params.agencyStatus = null
        }
      }
      //测试标准
      if (filters.testStandard != undefined) {
        var testStandard = filters.testStandard

        if (
          testStandard != undefined &&
          testStandard != null &&
          testStandard.length > 0
        ) {
          this.queryInfoparams.params.testStandard = testStandard.join(',')
        } else {
          this.queryInfoparams.params.testStandard = null
        }
      }

      this.search()
    },
    //导出excel
    exportExcel() {
      console.log('-----------')
      let res = this.$export('agent/exportExcel', JSON.stringify(this.queryInfoparams), 'agent manage')
    },
    //获取数据字典列表
    getDictList() {
      this.$get(`dict/getByTypeCodeAsFilter/TEST_STANDARD/Y`).then(
        ({ data: res }) => {
          this.testStandardList = res.data
        }
      )
    },
    //获取区域地址信息
    getAreaTreeList() {
      this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(
        ({ data: res }) => {
          this.areaTreeList = res.data
        }
      )
    },
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.search()
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询用户数据列表
    getDataList() {
      // 分页查询
      this.$post('agent/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听添加用户对话框的关闭事件
    dialogClosed() {
      this.addForm = {
        status: 0,
        testStandard: 'STANDARD',
      }
      this.dialogVisible = false
      this.$refs.editFormRef.resetFields()
    },
    // 点击按钮保存
    save() {
      this.$refs.editFormRef.validate(async (valid) => {
        // console.log('agencyArea',this.addForm.agencyArea)
        var agencyAreaList = this.addForm.agencyArea
        if (
          this.addForm.agencyArea != undefined &&
          this.addForm.agencyArea != null
        ) {
          this.addForm.agencyArea = this.addForm.agencyArea.join(',')
        }

        if (!valid) return
        const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        this.$post('agent/save', this.addForm)
          .then(({ data: res }) => {
            if (res.ok) {
              // 刷新列表数据
              this.addForm.agencyArea = agencyAreaList
              this.search()
              this.dialogClosed()
              loading.close()
              return this.$message.success(res.msg)
            } else {
              //报错时还原选择
              this.addForm.agencyArea = agencyAreaList
              this.$message.error(res.msg)
              loading.close()
            }
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    // 展示新增的对话框
    showAddDialog(id) {
      this.getAreaTreeList()
      this.addForm.status = 'Y'
      this.dialogVisible = true
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },
    // 批量启用代理商
    async enableBatch() {
      // console.log('multipleSelection', this.multipleSelection)
      // console.log('multipleSelection', this.multipleSelection.length)
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)

      // 弹框询问用户是否启用
      const confirmResult = await this.$confirm(
        'Enable Agent, keep continue?',
        'Enable Agent',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`agent/startAgencyStatus`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.search()
            }
          )
        })
        .catch(() => {})
    },

    // 批量禁用代理商
    async disableBatch() {
      console.log('multipleSelection', this.multipleSelection)
      console.log('multipleSelection', this.multipleSelection.length)
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)
      // 弹框询问用户是否禁用代理商
      const confirmResult = await this.$confirm(
        'Enable Agent, keep continue?',
        'Enable Agent',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`agent/stopAgencyStatus`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.search()
            }
          )
        })
        .catch(() => {})
    },
    // 展示分配用户的对话框
    goDetail(record) {
      this.$router.push({
        path: '/basic/agentinfo',
        query: { agentId: record.id, visible: true },
      })
    },
    //  账户是否存在
    async checkEmailExist() {
      if (this.addForm.loginAccount == '') return
      this.$get(`user/existsUser/${this.addForm.email}`).then(
        ({ data: res }) => {
          if (res.data === false) {
            this.$message.error('email was userd')
          }
        }
      )
    },
  },
  mounted() {
    this.search()
    this.getDictList()
  },
}
</script>

<style lang="less" >
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

.titleText {
  font-size: 14px;
  color: #a4a4a4;
}


</style>